import React, { FC, memo } from 'react';
import CheckboxListWithSearch from '@minecraft.checkbox-list-with-search';
import { useDrawerSearchFilterNameOrCategory } from '@minecraft.drawer';
import { FilterData } from '../../../shared/types';
import { Label } from '../../../shared/styles';
import { FiltersCategoryNameEnum } from '../../shared/types';

type Props = FilterData;

const Conflicts: FC<Props> = ({ name, label }) => {
  const { isSearching, getMatchedSearchOptions } = useDrawerSearchFilterNameOrCategory(
    FiltersCategoryNameEnum.excludeTalentWithConflicts
  );

  return (
    <>
      {isSearching && <Label>{label}</Label>}
      <CheckboxListWithSearch
        withSearch={!isSearching}
        withSelectAll
        withFormik
        name={name}
        options={getMatchedSearchOptions(name)}
      />
    </>
  );
};

export default memo(Conflicts);
